export const radioColors = {
    main: 'seaBlue.main',
    hover: 'seaBlue.40',
    disabled: 'sandstone.main'
};
